import React from "react";
import ShimmerCard from "./ShimmerCard"; // Import the shimmer component

interface ShimmerGridProps {
	count?: number;
}

const ShimmerGrid: React.FC<ShimmerGridProps> = ({ count = 12 }) => {
	return (
		<div className="row m-0 p-0">
			{Array.from({ length: count }).map((_, index) => (
				<ShimmerCard key={index} />
			))}
		</div>
	);
};

export default ShimmerGrid;
